import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userApi from "api/user/user.api";
import { AxiosError } from "axios";

// Interface cho User và trạng thái Auth
// interface User {
//   _id: string;
//   photo: string;
//   dateOfBirth: string;
//   gender: string;
//   phone: string;
//   bio: string;
//   displayName: string;
//   username: string;
//   token: string;
//   isVerified?: boolean; // <== ✅ add this line
// }

export interface User {
  _id: string;
  id: string;
  username: string;
  displayName: string;
  email?: string;
  photo?: string;
  isVerified?: boolean;
  dateOfBirth?: string;
  gender?: string;
  phone?: string;
  token?: string;
  bio?: string;
  // add more if needed
}

interface LoginPayload {
  username: string;
  password: string;
}

interface SignUpPayload {
  username: string;
  password: string;
  confirmPassword: string;
  displayName: string;
  photo: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }: LoginPayload, { rejectWithValue }) => {
    try {
      const { response, err } = await userApi.signin({ username, password });

      if (response) {
        localStorage.setItem("token", response.data.token || "");
        return response.data; // return only the user data
      }

      if (err) {
        const axiosError = err as AxiosError<any>;
        return rejectWithValue(
          axiosError.response?.data?.message || "Login failed"
        );
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

// export const signup = createAsyncThunk(
//   "auth/signup",
//   async (
//     { username, password, confirmPassword, displayName, photo }: SignUpPayload,
//     { rejectWithValue }
//   ) => {
//     if (password !== confirmPassword) {
//       return rejectWithValue("Passwords do not match");
//     }

//     try {
//       const response = await userApi.signup({
//         username,
//         password,
//         confirmPassword,
//         displayName,
//         photo,
//       });
//       localStorage.setItem("token", response.token);

//       return response;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || "Signup failed");
//     }
//   }
// );

// Tạo authSlice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem("token"); // Xóa token khi người dùng logout
      localStorage.removeItem("rftkn"); // Xóa refresh token khi người dùng logout
    },
    setUser: (state, action) => {
      if (action.payload === null) {
        localStorage.removeItem("token"); // or "actkn" if you prefer your original key
        localStorage.removeItem("rftkn"); // Xóa refresh token khi người dùng logout
      } else {
        if (action.payload.token)
          localStorage.setItem("token", action.payload.token);
        if (action.payload?.refreshToken) {
          localStorage.setItem("rftkn", action.payload.refreshToken);
        }
      }
      state.user = action.payload;
      state.token = action.payload?.token || null;
      state.isAuthenticated = !!action.payload; // true if user exists
    },
  },
  // extraReducers: (builder) => {
  //   builder;
  //   // .addCase(login.pending, (state) => {
  //   //   state.isLoading = true;
  //   //   state.error = null;
  //   // })
  //   // .addCase(login.fulfilled, (state, action) => {
  //   //   console.log(action.payload);

  //   //   state.isLoading = false;
  //   //   state.isAuthenticated = true;

  //   //   state.user = {
  //   //     _id: action.payload._id,
  //   //     photo: action.payload.photo,
  //   //     dateOfBirth: action.payload.dateOfBirth,
  //   //     gender: action.payload.gender,
  //   //     phone: action.payload.phone,
  //   //     bio: action.payload.bio,
  //   //     displayName: action.payload.displayName,
  //   //     username: action.payload.username,
  //   //     token: action.payload.token,
  //   //   };

  //   //   state.token = action.payload.token;
  //   // })
  //   // .addCase(signup.fulfilled, (state, action) => {
  //   //   console.log(action.payload);

  //   //   state.isLoading = false;
  //   //   state.isAuthenticated = true;

  //   //   state.user = {
  //   //     _id: action.payload._id,
  //   //     photo: action.payload.photo,
  //   //     dateOfBirth: action.payload.dateOfBirth,
  //   //     gender: action.payload.gender,
  //   //     phone: action.payload.phone,
  //   //     bio: action.payload.bio,
  //   //     displayName: action.payload.displayName,
  //   //     username: action.payload.username,
  //   //     token: action.payload.token,
  //   //   };

  //   //   state.token = action.payload.token;
  //   // })
  //   // .addCase(login.rejected, (state, action) => {
  //   //   state.isLoading = false;
  //   //   state.error = action.payload as string;
  //   // });
  //   // .addCase(signup.rejected, (state, action) => {
  //   //   state.isLoading = false;
  //   //   state.error = action.payload as string;
  //   // });
  // },
});

export const { logout, setUser } = authSlice.actions;
export default authSlice.reducer;
